import React, { useCallback } from 'react';
import range from 'lodash/range';
import Placeholder from '../Placeholder';
import SidebarGrid from '../SidebarGrid';
import TitlePlaceholder from '../TitlePlaceholder';
import s from './LoaderBlock.scss';
var items = range(0, 9);
var LoaderBlock = function (_a) {
    var index = _a.index;
    var renderItem = useCallback(function (_a) {
        var item = _a.item, width = _a.width, height = _a.height, itemClassName = _a.className;
        return (React.createElement(Placeholder, { key: item, width: width, height: height, className: itemClassName }));
    }, []);
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['block-header'] },
            React.createElement(TitlePlaceholder, { splitIndex: index })),
        React.createElement(SidebarGrid, { items: items, maxRows: 3, renderItem: renderItem })));
};
LoaderBlock.displayName = 'LoaderBlock';
export default LoaderBlock;
//# sourceMappingURL=LoaderBlock.js.map